import { useEffect, useState } from "react";
import DataTable from "react-data-table-component";
import CheckBox from "./CheckBox";
import ButtonIconH from "./ButtonIconH";
import { CRMListsColumns, CRMPatientListColumns } from "../js/tableColumns";
import { post } from "../js/post";
import { formatValueUnit, userData } from "../js/utils";

export function CRMList({
  data,
  createPopupQuestion,
  removePopupQuestion,
  onClose,
  onRemovePatients,
}) {
  const [start, setStart] = useState(0);
  const [totalPatients, setTotalPatients] = useState(0);
  const [patientsList, setPatientsList] = useState([]);
  const [patientsListFixed, setPatientsListFixed] = useState([]);
  const [selectedPatientsList, setSelectedPatientsList] = useState([]);
  const [currentList, setCurrentList] = useState(data);

  // console.log("DATOS LISTA: ", currentList);

  const columnsWithInputs = CRMPatientListColumns.map((col) => {
    if (col.name === "" && !currentList.soloLectura) {
      return {
        ...col,
        selector: (row) => (
          <CheckBox
            active={selectedPatientsList.includes(row.idPaciente)}
            onClick={() => handleCheckboxChange(row.idPaciente)}
          />
        ),
      };
    }

    return col;
  });

  async function getList(id) {
    const response = await post("support-extra/crm/ObtenerListaCRM.php", {
      token: userData.token,
      idLista: id,
    });
    // console.log(
      // "OBTENIENDO LISTA: ",
      // {
        // token: userData.token,
        // idLista: id,
      // },
      // response,
    // );
    setCurrentList(response);
  }

  function handleCheckboxChange(patientId) {
    setSelectedPatientsList((prevSelected) =>
      prevSelected.includes(patientId)
        ? prevSelected.filter((id) => id !== patientId)
        : [...prevSelected, patientId],
    );
  }

  function handleSelectAll() {
    setSelectedPatientsList((prev) => {
      const newIds = patientsList
        .filter((e) => !prev.includes(e.idPaciente))
        .map((e) => e.idPaciente);

      return [...prev, ...newIds];
    });
  }

  function handleCleanAll() {
    setSelectedPatientsList([]);
  }

  async function getPatientsList(start) {
    const response = await post(
      "support-extra/crm/ListarPacientesListaCRM.php",
      {
        token: userData.token,
        idLista: currentList.idLista,
        start: start,
      },
    );
    // console.log(
      // "LISTANDO PACIENTES: ",
      // {
        // token: userData.token,
        // idLista: currentList.idLista,
        // start: start,
      // },
      // response,
    // );
    setTotalPatients(response.total);
    if (start === 0) {
      setPatientsList(response.pacientes);
      setPatientsListFixed(response.pacientes);
    } else {
      setPatientsList((prev) => [...prev, ...response.pacientes]);
      setPatientsListFixed((prev) => [...prev, ...response.pacientes]);
    }
  }

  async function deleteList() {
    await post("support-extra/crm/EliminarListaCRM.php", {
      token: userData.token,
      idListas: [currentList.idLista],
    });
    // console.log("ELIMINANDO LISTA: ", {
      // token: userData.token,
      // idListas: [currentList.idLista],
    // });
  }

  async function deletePatientsList() {
    await post("support-extra/crm/EliminarPacientesListaCRM.php", {
      token: userData.token,
      idLista: currentList.idLista,
      idPacientes: selectedPatientsList,
    });
    // console.log("ELIMINANDO PACIENTES LISTAS: ", {
      // token: userData.token,
      // idLista: currentList.idLista,
      // idPacientes: selectedPatientsList,
    // });
  }

  useEffect(() => {
    setCurrentList(data);
  }, [data]);

  useEffect(() => {
    getPatientsList(start);
  }, [start]);

  return (
    <div className="crm-list-container">
      <div className="container-panel">
        <DataTable
          columns={CRMListsColumns}
          data={[currentList]}
          className="custom-datatable non-interactive"
          noDataComponent="No hay datos disponibles."
        />
      </div>
      <div className="container-panel">
        <div className="opt-table-title opt-table-title-button">
          <div>
            Listado de pacientes ({formatValueUnit(patientsListFixed.length)} de{" "}
            <span style={{ color: "#41b3ff" }}>
              {formatValueUnit(totalPatients)}
            </span>
            )
          </div>
          {!currentList.soloLectura && (
            <div
              style={{
                display: "flex",
                alignItems: "center",
                gap: 30,
              }}
            >
              <ButtonIconH
                text="Eliminar lista"
                small={true}
                onClick={async () => {
                  createPopupQuestion(
                    "¿Desea eliminar esta lista?",
                    async () => {
                      await deleteList();
                      onClose();
                      removePopupQuestion();
                    },
                    () => {
                      removePopupQuestion();
                    },
                    "Sí",
                    "No",
                  );
                }}
              ></ButtonIconH>
              {totalPatients > 0 && (
                <ButtonIconH
                  text="Eliminar seleccionados"
                  small={true}
                  disabled={selectedPatientsList.length === 0}
                  onClick={async () => {
                    createPopupQuestion(
                      "¿Desea eliminar los pacientes seleccionados?",
                      async () => {
                        removePopupQuestion();
                        setSelectedPatientsList([]);
                        setPatientsListFixed([]);
                        await deletePatientsList();
                        await getPatientsList(0);
                        await getList(currentList.idLista);
                        setStart(0);
                        onRemovePatients();
                      },
                      () => {
                        removePopupQuestion();
                      },
                      "Sí",
                      "No",
                    );
                  }}
                ></ButtonIconH>
              )}
            </div>
          )}
        </div>
        {totalPatients > 0 && !currentList.soloLectura && (
          <div
            style={{
              display: "flex",
              flexDirection: "row",
              gap: 5,
              justifyContent: "flex-end",
              paddingBottom: 10,
            }}
          >
            <button
              className="cell-label"
              onClick={handleSelectAll}
              tabIndex={-1}
            >
              Seleccionar todos
            </button>
            |
            <button className="cell-label" onClick={handleCleanAll}>
              Limpiar selección
            </button>
          </div>
        )}
        <DataTable
          columns={columnsWithInputs}
          data={patientsListFixed}
          className="custom-datatable"
          noDataComponent="No hay pacientes disponibles."
        />
        {patientsListFixed.length !== totalPatients && (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              marginTop: 20,
            }}
          >
            <ButtonIconH
              text="Ver más (+20)"
              small={true}
              onClick={() => {
                setStart((prev) => prev + 20);
              }}
            ></ButtonIconH>
          </div>
        )}
      </div>
    </div>
  );
}
